import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const TimeCalculatorPage = () => {
  const [calcType, setCalcType] = useState('add');
  const [hours1, setHours1] = useState('');
  const [minutes1, setMinutes1] = useState('');
  const [seconds1, setSeconds1] = useState('');
  const [hours2, setHours2] = useState('');
  const [minutes2, setMinutes2] = useState('');
  const [seconds2, setSeconds2] = useState('');
  const [result, setResult] = useState(null);

  const calculate = () => {
    const totalSec1 = (parseInt(hours1) || 0) * 3600 + (parseInt(minutes1) || 0) * 60 + (parseInt(seconds1) || 0);
    const totalSec2 = (parseInt(hours2) || 0) * 3600 + (parseInt(minutes2) || 0) * 60 + (parseInt(seconds2) || 0);

    let resultSec;
    if (calcType === 'add') {
      resultSec = totalSec1 + totalSec2;
    } else {
      resultSec = totalSec1 - totalSec2;
    }

    const isNegative = resultSec < 0;
    resultSec = Math.abs(resultSec);

    const h = Math.floor(resultSec / 3600);
    const m = Math.floor((resultSec % 3600) / 60);
    const s = resultSec % 60;

    setResult({ hours: h, minutes: m, seconds: s, isNegative, totalSeconds: resultSec });
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Time Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-2">Time Calculator</h1>
          <p className="text-gray-400 mb-8">Add or subtract time durations.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="flex gap-4 mb-5">
              <button onClick={() => setCalcType('add')} className={`px-4 py-2 rounded-lg font-medium ${calcType === 'add' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Add Time</button>
              <button onClick={() => setCalcType('subtract')} className={`px-4 py-2 rounded-lg font-medium ${calcType === 'subtract' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Subtract Time</button>
            </div>
            <div className="space-y-5">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Time 1</label>
                <div className="flex gap-2 items-center">
                  <Input type="number" value={hours1} onChange={(e) => setHours1(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">h</span>
                  <Input type="number" value={minutes1} onChange={(e) => setMinutes1(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">m</span>
                  <Input type="number" value={seconds1} onChange={(e) => setSeconds1(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">s</span>
                </div>
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Time 2</label>
                <div className="flex gap-2 items-center">
                  <Input type="number" value={hours2} onChange={(e) => setHours2(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">h</span>
                  <Input type="number" value={minutes2} onChange={(e) => setMinutes2(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">m</span>
                  <Input type="number" value={seconds2} onChange={(e) => setSeconds2(e.target.value)} className="w-16 bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="0" /><span className="text-gray-400">s</span>
                </div>
              </div>
            </div>
            <Button onClick={calculate} className="mt-5 bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
            {result && (
              <div className="mt-6 p-5 bg-cyan-500/10 border border-cyan-500/30 rounded-xl text-center">
                <span className="text-gray-400">Result</span>
                <p className="text-3xl font-bold text-cyan-400">{result.isNegative ? '-' : ''}{result.hours}:{result.minutes.toString().padStart(2, '0')}:{result.seconds.toString().padStart(2, '0')}</p>
                <p className="text-gray-500 text-sm mt-1">({result.totalSeconds.toLocaleString()} total seconds)</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TimeCalculatorPage;
